// ProgressBar - Animated progress bar component
// Props: progress (0-100), color, height
interface ProgressBarProps {
  progress: number
  color?: string
  height?: number
}

export default function ProgressBar({ progress, color, height = 6 }: ProgressBarProps) {
  return (
    <div
      style={{
        width: '100%',
        height,
        borderRadius: height / 2,
        background: 'var(--progress-bg)',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${Math.min(100, Math.max(0, progress))}%`,
          height: '100%',
          background: color ?? 'var(--progress-fill)',
          transition: 'width 0.3s ease',
          borderRadius: height / 2,
        }}
      />
    </div>
  )
}
